import React, { useCallback, useRef, useState } from 'react';
import { ShieldAlert } from 'lucide-react';

// Hold 2 seconds to trigger. Prevents accidental SOS.
export const HoldSOSButton = ({ onTrigger, testid = 'active-ride-hold-sos-button' }) => {
  const [progress, setProgress] = useState(0);
  const [triggered, setTriggered] = useState(false);
  const rafRef = useRef(null);
  const startRef = useRef(0);
  const DURATION = 2000;

  const stop = useCallback(() => {
    cancelAnimationFrame(rafRef.current);
    if (!triggered) setProgress(0);
  }, [triggered]);

  const tick = useCallback(() => {
    const elapsed = Date.now() - startRef.current;
    const p = Math.min(1, elapsed / DURATION);
    setProgress(p);
    if (p >= 1) {
      setTriggered(true);
      if (navigator.vibrate) navigator.vibrate([80, 40, 80]);
      onTrigger && onTrigger();
      setTimeout(() => { setTriggered(false); setProgress(0); }, 800);
      return;
    }
    rafRef.current = requestAnimationFrame(tick);
  }, [onTrigger]);

  const start = useCallback((e) => {
    e.preventDefault();
    if (triggered) return;
    startRef.current = Date.now();
    rafRef.current = requestAnimationFrame(tick);
  }, [tick, triggered]);

  return (
    <button
      data-testid={testid}
      onMouseDown={start}
      onMouseUp={stop}
      onMouseLeave={stop}
      onTouchStart={start}
      onTouchEnd={stop}
      className="relative w-full overflow-hidden rounded-2xl min-h-[56px] font-bold text-base select-none"
      style={{ background: 'var(--surface)', color: 'var(--danger)', border: '2px solid var(--danger)' }}
    >
      <span
        className="absolute inset-y-0 left-0"
        style={{ width: `${progress * 100}%`, background: 'var(--danger)', transition: 'width 0.05s linear', opacity: 0.18 }}
      />
      <span className="relative flex items-center justify-center gap-2">
        <ShieldAlert size={20} />
        {triggered ? 'SOS sent' : progress > 0 ? 'Keep holding…' : 'Hold for SOS'}
      </span>
    </button>
  );
};
